// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__23px8","label":"input_label__1bdsR","error":"input_error__3hyp6"};